import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import HEQualsDropDownViewModel from '../ViewModels/HEQualsDropDownViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IHEQualsDropDownProps {
    setHEQualsDropDown?: (event) => void;
    heQuals: string | undefined;
    disabled: boolean;
}

interface IHEQualsDropDownState {
    model: HEQualsDropDownViewModel[];
    loaded: boolean;
}

class HEQualsDropDown extends Component<IHEQualsDropDownProps & WithStyles<typeof styles>, IHEQualsDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetHEQuals').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultHEQualsVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label="What is your highest level of qualification?"
                name="heQuals"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.heQuals}
                onChange={this.props.disabled ? undefined : this.props.setHEQualsDropDown}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(HEQualsDropDown);